import { NormalizedCacheObject } from '@apollo/client';
import { ApolloClient } from '@apollo/client';
import { loader } from 'graphql.macro';
import { Nullable } from 'common-types';
import { logger } from 'logging-utils';
import TelemetryManager, { TelemetryActions } from '../../../telemetry';
import {
  CreatePullRequestInput,
  PullRequest,
} from '../../types/quick-fix-types';

const mutation = loader('./create-pr.gql');

const createPullRequest = (client: ApolloClient<NormalizedCacheObject>) => {
  return {
    execute: async (
      input: CreatePullRequestInput,
    ): Promise<Nullable<PullRequest>> => {
      try {
        const results = await client.mutate<CreatePullRequestMutation>({
          mutation,
          variables: { input },
        });

        if (!results.data || !results.data.createPullRequestById) {
          return null;
        }

        TelemetryManager.setTelemetryAction(TelemetryActions.CreatePR, input);
        return results.data.createPullRequestById;
      } catch (error) {
        logger.error('Failed to create pull request', error);
        throw error;
      }
    },
  };
};

interface CreatePullRequestMutation {
  createPullRequestById: PullRequest;
}

export default createPullRequest;
